import { Panel, PanelType } from "office-ui-fabric-react";
import { UserState } from '../../store/User';
import * as React from 'react';
import { ApplicationState } from '../../store';
import { connect } from "react-redux";
import { PANEL_CUSTOM_WIDTH } from "../../entities/common";
import { HubspotEventListener, HubspotInlineWidget } from "./HubspotMeeting";

type StateProps = {
    user: UserState;
    calendarEventPath: string;
}

type OwnProps = {
    headerText?: JSX.Element;
    headerDescription?: JSX.Element;
    onDismiss: () => void
}

type Props = OwnProps & StateProps

export class CalendarPanel extends React.Component<Props> {

    private onDismiss = (): void => {
        this.props.onDismiss()
    };

    public render() {
        return <Panel
                isLightDismiss
                type={PanelType.custom}
                customWidth="500px"
                onRenderHeader={this._onRenderHeader}
                className="calendar-panel"
                isOpen={true}
                onDismiss={this.onDismiss}>
            <div className="embed">
                <HubspotEventListener>
                    <HubspotInlineWidget
                        url={this.props.calendarEventPath}
                        prefill={{
                            email: this.props.user.email,
                            firstName: this.props.user.name?.split(' ')[0],
                            lastName: this.props.user.name?.split(' ').slice(1).join(' ')
                        }} />
                    </HubspotEventListener>
                </div>
            </Panel>
        
    }

    private _onRenderHeader = (): JSX.Element | null => {
        return <div className="ms-Panel-header">
            <p className="ms-Panel-headerText">{this.props.headerText ?? "Request PPM Express Trial"}</p>
            <p className="ms-Panel-secondaryText">
                {this.props.headerDescription
                    ?? "Book a discovery call with our team to learn how it would integrate with YOUR system and start a Trial."}
            </p>
        </div>;
    }
}

function mapStateToProps(state: ApplicationState): StateProps {
    return {
        user: state.user,
        calendarEventPath: state.analytics.calendarEventPath
    }
}

export default (connect(mapStateToProps)(CalendarPanel));